import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { Subscription } from 'rxjs';

import { AbstractFormFieldComponent } from '../../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { ChartDisplayElementModel } from '../../../../Common/Reports/models/chart-display-element.model';
import { ChartMetricsEnum } from '../../../../Common/Reports/enums/chart-metrics.enum';
import { CoverageMetricChartDisplaySettingsField } from '../../../../Common/Reports/models/coverage-metric-chart-display-settings-field.model';
import { CoverageMetricChartDisplaySettings } from '../../../../Common/Charts/models/coverage-metric-chart-display-settings.model';
import { CoverageMetricChartDisplayElement } from '../../../../Common/Reports/models/coverage-metric-chart-display-element.model';
import { DateQueryTypeEnum } from '../../../../api/mentions/enum/date-query-type.enum';


@Component({
    selector: 'agpr-coverage-metric-chart-display-settings-field',
    templateUrl: './coverage-metric-chart-display-settings-field.component.html',
    styleUrls: ['./coverage-metric-chart-display-settings-field.component.scss'],
    standalone: false
})
export class CoverageMetricChartDisplaySettingsFieldComponent extends AbstractFormFieldComponent implements OnInit, OnDestroy, OnChanges {

    @Input() override field: CoverageMetricChartDisplaySettingsField;
    @Input() override value: CoverageMetricChartDisplaySettings;

    displaySourceAsLink: boolean = true;
    isCustom: boolean;
    displayPreviousPeriod: boolean = true;
    displaySettingsFormGroup = new FormGroup({
        title: new FormControl<boolean>(false),
        icon: new FormControl<boolean>(false),
        dateRange: new FormControl<boolean>(false),
        sourceLink: new FormControl<boolean>(false),
        previousPeriod: new FormControl<boolean>(false),
        customPreviousValue: new FormControl<string>(null),
        sparkChart: new FormControl<boolean>(false)
    });

    subscriptions: Subscription[] = [];

    constructor(private pageBuilderService: AbstractPageBuilderService) {
        super();
    }

    ngOnInit(): void {
        this.displaySourceAsLink = this.pageBuilderService.getDisplaySourceAsLink();
        this.isCustom = (this.block.displayElement as ChartDisplayElementModel).metric === ChartMetricsEnum.custom;
        this.title.setValue(this.value.title);
        this.icon.setValue(this.value.icon);
        this.dateRange.setValue(this.value.dateRange);
        this.sourceLink.setValue(this.value.sourceLink);
        this.previousPeriod.setValue(this.value.previousPeriod);
        this.customPreviousValue.setValue(this.value.customPreviousValue);
        this.sparkChart.setValue(this.value.sparkChart);

        this.subscriptions.push(
            this.displaySettingsFormGroup.valueChanges.subscribe(value => {
                this.emitChanges(value);
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(x => x.unsubscribe());
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.isCustom = (this.block.displayElement as CoverageMetricChartDisplayElement).metric === ChartMetricsEnum.custom;
        if (this.isCustom) {
            (this.block.displayElement as CoverageMetricChartDisplayElement).chartHeaderSettings.dateRange = false;
            (this.block.displayElement as CoverageMetricChartDisplayElement).chartHeaderSettings.sourceLink = false;
        }
        if ((this.block.displayElement as CoverageMetricChartDisplayElement).series[0].dateRange.type === DateQueryTypeEnum.ALL) {
            if (this.value.previousPeriod) {
                this.value.previousPeriod = false;
                this.previousPeriod.setValue(this.value.previousPeriod, { onlySelf: true });
                this.emitChanges(this.value);
            }
            this.displayPreviousPeriod = false;
        } else {
            this.displayPreviousPeriod = true;
        }
    }

    emitChanges(value: any): void {
        const displaySettings = new CoverageMetricChartDisplaySettings({
            title: value.title,
            icon: value.icon,
            dateRange: value.dateRange,
            sourceLink: value.sourceLink,
            previousPeriod: value.previousPeriod,
            customPreviousValue: value.customPreviousValue,
            sparkChart: value.sparkChart,
            displaySourceAsLink: this.displaySourceAsLink
        });
        (this.block.displayElement as CoverageMetricChartDisplayElement).styles.chartDisplaySettings = displaySettings;
        this.changes.emit(displaySettings);
    }

    get title(): FormControl {
        return this.displaySettingsFormGroup.get('title') as FormControl;
    }

    get icon(): FormControl {
        return this.displaySettingsFormGroup.get('icon') as FormControl;
    }

    get dateRange(): FormControl {
        return this.displaySettingsFormGroup.get('dateRange') as FormControl;
    }

    get sourceLink(): FormControl {
        return this.displaySettingsFormGroup.get('sourceLink') as FormControl;
    }

    get previousPeriod(): FormControl {
        return this.displaySettingsFormGroup.get('previousPeriod') as FormControl;
    }

    get customPreviousValue(): FormControl {
        return this.displaySettingsFormGroup.get('customPreviousValue') as FormControl;
    }

    get sparkChart(): FormControl {
        return this.displaySettingsFormGroup.get('sparkChart') as FormControl;
    }
}
